import React from 'react';

import { ProductType } from '../../../types';
import { PRODUCT_DETAILS } from '../constants';

import styles from './SelectedOptions.module.css';

interface Props {
  dataHcName: string;
  productType: ProductType;
}

export const ProductOption = ({ dataHcName, productType }: Props) => {
  const { Icon, title, description, iconProps } = PRODUCT_DETAILS[productType];

  return (
    <div data-hc-name={dataHcName} className={styles.Option}>
      <div className={styles.OptionContent} data-hc-name="order-form-option">
        <div className={styles.OptionIcon}>
          <Icon {...iconProps} />
        </div>
        <div>
          <h4 className={styles.OptionTitle} data-hc-name="option-form-name">
            {title}
          </h4>
          <div
            className={styles.OptionDescription}
            data-hc-name="option-form-description"
          >
            {description}
          </div>
        </div>
      </div>
    </div>
  );
};
